import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { RetryConfirmationList } from '../styled-components'

const RetryConfirmationChecks = ({ emailChecked, spamChecked, onEmailChange, onSpamChange, hidden }) => {
  const { t } = useTranslation()

  if (hidden) {
    return null
  }

  return (
    <RetryConfirmationList>
      <SDCheckbox
        checked={emailChecked}
        onChange={onEmailChange}
        label={t('additionalSales:common.retry_confirmation_email')}
      />
      <SDCheckbox
        checked={spamChecked}
        onChange={onSpamChange}
        label={t('additionalSales:common.retry_confirmation_spam')}
      />
    </RetryConfirmationList>
  )
}

RetryConfirmationChecks.propTypes = {
  emailChecked: PropTypes.bool,
  spamChecked: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  onSpamChange: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
}

export default RetryConfirmationChecks
